<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <div class="row">
        <h5 *ngIf="contract.id; else titleBlock" class="modal-title container"
          i18n>Editar Contrato</h5>
        <ng-template #titleBlock>
          <h5 class="modal-title container" i18n>Novo Contrato</h5>
        </ng-template>
      </div>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="contractForm" (submit)="onSubmit()">
        <div class="row">
          <div class="col-3">
            <div class="form-group">
              <app-input i18n-label="@@Code" type="text" formControlName="code"
                [inputDisabled]="enabledContractNumber"
                inputRequired=true label="Código do Contrato"
                (change)="checkContractCode($event, 'code')">
              </app-input>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <app-input i18n-label="@@Code" type="text" formControlName="name"
                inputRequired=true label="Nome do Contrato">
              </app-input>
            </div>
          </div>
          <div class="col-5">
            <div class="form-group form-status">
              <label class="form-control-label required">Status:</label>
              <div class="buttons d-flex justify-content-between">
                <button
                  type="button"
                  (click)="setContractStatus(contractStatusType.Active)"
                  class="btn"
                  [ngClass]="{
                    'btn-outline-secondary': contractStatus !== contractStatusType.Active,
                    'btn-primary': contractStatus === contractStatusType.Active
                  }">Ativo</button>
                <button
                  type="button"
                  (click)="setContractStatus(contractStatusType.Closed)"
                  class="btn"
                  [ngClass]="{
                    'btn-outline-secondary': contractStatus !== contractStatusType.Closed,
                    'btn-primary': contractStatus === contractStatusType.Closed
                  }">Fechado</button>
                <button
                  type="button"
                  (click)="setContractStatus(contractStatusType.Test)"
                  class="btn"
                  [ngClass]="{
                    'btn-outline-secondary': contractStatus !== contractStatusType.Test,
                    'btn-primary': contractStatus === contractStatusType.Test
                  }">Em Teste</button>
                <button
                  type="button"
                  (click)="setContractStatus(contractStatusType.History)"
                  class="btn"
                  [ngClass]="{
                    'btn-outline-secondary': contractStatus !== contractStatusType.History,
                    'btn-primary': contractStatus === contractStatusType.History
                  }">Histórico</button>
                <button
                  type="button"
                  (click)="setContractStatus(contractStatusType.Expired)"
                  class="btn"
                  [ngClass]="{
                    'btn-outline-secondary': contractStatus !== contractStatusType.Expired,
                    'btn-primary': contractStatus === contractStatusType.Expired
                  }">Vencido</button>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <app-input i18n-label type="text"
                formControlName="internalCode"
                label="Código Interno"
                (change)="checkContractCode($event, 'internalCode')">
              </app-input>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <app-input i18n-label i18n-placeholder placeholder="Empresas"
                inputRequired=true
                label="Empresas" type="multiselect" selectText="name"
                selectValue="id"
                [list]="companies" formControlName="companyIds"
                selectShowLimit="5">
              </app-input>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <app-input type="select" [list]="selectedCompanies"
                label="Empresa Responsável" formControlName="ownerCompanyId"
                selectText="name" selectValue="id"
                placeholder="Selecione uma empresa"
                [ngClass]="{'disabled': !ownerCompanyActive}"
                i18n-placeholder inputRequired=true i18n-label
                toolTipMsg="Preencha este campo apenas se houver mais de uma empresa vinculada ao contrato.">
              </app-input>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <app-input type="select" [list]="regions" label="Região"
                formControlName="regionId"
                selectText="name" selectValue="id"
                placeholder="Selecione uma região"
                i18n-placeholder inputRequired=true i18n-label
                (ngModelChange)="getRegulation($event)">
              </app-input>
            </div>
          </div>
        </div>
        <fieldset>
          <legend class="required" i18n>Período Vigência</legend>
          <div class="row">
            <div class="col-12 col-md-3">
              <div class="form-group">
                <label class="required" i18n>Data Inicial</label>
                <div class="input-group input-group--adjust">
                  <div class="input-group-prepend"
                    *ngIf="!contractForm.get('startsAt').invalid || !contractForm.get('startHour').invalid">
                    <div class="input-group-text">
                      <i class="material-icons">date_range</i>
                    </div>
                  </div>
                  <app-input class="input-group--input-prepend" type="date"
                    formControlName="startsAt"
                    inputRequired=true hasLabel=false></app-input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="form-group">
                <label class="required" i18n>Hora Inicial</label>
                <div class="input-group input-group--adjust">
                  <div class="input-group-prepend">
                    <div class="input-group-text"
                      *ngIf="!contractForm.get('startHour').invalid">
                      <i class="material-icons">access_time</i>
                    </div>
                  </div>
                  <app-input class="input-group--input-prepend"
                    format="dd:dd:dd" formControlName="startHour"
                    inputRequired=true hasLabel=false></app-input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="form-group">
                <label i18n>Data Final</label>
                <div class="input-group input-group--adjust">
                  <div class="input-group-prepend"
                    *ngIf="!contractForm.get('endsAt').invalid || !contractForm.get('endHour').invalid">
                    <div class="input-group-text">
                      <i class="material-icons">date_range</i>
                    </div>
                  </div>
                  <app-input class="input-group--input-prepend" type="date"
                    formControlName="endsAt"
                    hasLabel=false></app-input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="form-group">
                <label i18n>Hora Final</label>
                <div class="input-group input-group--adjust">
                  <div class="input-group-prepend">
                    <div class="input-group-text"
                      *ngIf="!contractForm.get('endHour').invalid">
                      <i class="material-icons">access_time</i>
                    </div>
                  </div>
                  <app-input class="input-group--input-prepend"
                    format="dd:dd:dd" formControlName="endHour"
                    hasLabel=false></app-input>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <div class="row mt-4">
          <div class="col-md-12">
            <label i18n><strong>Ambiente Utilizado:</strong></label>
            <div class="row mt-1">
              <div class="col-md-3">
                <div class="row mt-1">
                  <div class="col-auto">
                    <mat-checkbox color="primary"
                      formControlName="ecs"
                      (change)="enabledChekcbox($event.checked)"
                      i18n>eCS</mat-checkbox>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="row mt-1">
                  <div class="col-auto">
                    <mat-checkbox color="primary" i18n
                      formControlName="bequest"
                      (change)="enabledLegacyCheckbox($event.checked)">Legado</mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-featured ecs-modules mt-4">
          <div class="button d-flex justify-content-between">
            <h5 class="mb-3" i18n>
              <strong>eCS:</strong>
            </h5>
            <button
              type="button"
              class="btn text-secondary btn-icon-block"
              (click)="openOrCloseEcsModules()">
              <i class="material-icons"
                *ngIf="ecsModules.open">unfold_less</i>
              <i class="material-icons"
                *ngIf="!ecsModules.open">unfold_more</i>
            </button>
          </div>
          <div class="content" *ngIf="ecsModules.open">
            <div class="row">
              <div class="col-md-12" *ngIf="user.superUser || gb.isOn('ECS-5791')">
              <label i18n><strong>Interfaces Habilitadas:</strong></label>
                <div class="row mt-1">
                  <div class="col-md-3">
                    <div class="row mt-1">
                      <div class="col-auto">
                        <mat-checkbox color="primary" class="mr-1"
                          formControlName="omnia" [disabled]="checkBoxes"
                          i18n>Omnia</mat-checkbox>
                        <i i18n-appTooltip
                          class="material-icons icon-sm text-secondary"
                          appTooltip="Responsável pela comunicação dos cadastros básicos da plataforma.">
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mt-1">
                      <div class="col-auto">
                        <mat-checkbox color="primary" class="mr-1"
                          formControlName="initus" [disabled]="checkBoxes"
                          i18n>Initus</mat-checkbox>
                        <i i18n-appTooltip
                          class="material-icons icon-sm text-secondary"
                          appTooltip="Responsável pela recepção de infrações, enviadas por equipamentos de rua ou outras APIs.">
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mt-1">
                      <div class="col-auto">
                        <mat-checkbox color="primary" class="mr-1"
                          formControlName="initusTraffic"
                          [disabled]="checkBoxes"
                          i18n>Initus Traffic</mat-checkbox>
                        <i i18n-appTooltip
                          class="material-icons icon-sm text-secondary"
                          appTooltip="Responsável pela recepção de passagens (registros de veículos), enviadas por equipamentos de rua ou outras APIs.">
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <label i18n><strong>Módulos Habilitados:</strong></label>
                <div class="row mt-1">
                  <div class="col-md-3">
                    <div class="row mt-1">
                      <div class="col-auto">
                        <mat-checkbox color="primary"
                          formControlName="preProcess" [disabled]="checkBoxes"
                          i18n>Pré-Processamento</mat-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mt-1">
                      <div class="col-auto">
                        <mat-checkbox color="primary"
                          formControlName="violations" [disabled]="checkBoxes"
                          i18n>Infração</mat-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mt-1">
                      <div class="col-auto">
                        <mat-checkbox color="primary"
                          formControlName="traffic" [disabled]="checkBoxes"
                          i18n>Passagem</mat-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mt-1">
                      <div class="col-auto">
                        <mat-checkbox color="primary"
                          formControlName="status" [disabled]="checkBoxes"
                          i18n>Status</mat-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mt-1">
                      <div class="col-auto">
                        <mat-checkbox color="primary"
                          formControlName="monitoring" [disabled]="checkBoxes"
                          i18n>eCS-Spy</mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-featured legacy-modules my-4">
          <div class="button d-flex justify-content-between">
            <h5 class="mb-3" i18n>
              <strong>Legado:</strong>
            </h5>
            <button
              type="button"
              class="btn text-secondary btn-icon-block"
              (click)="openOrCloseLegacyModules()">
              <i class="material-icons"
                *ngIf="legacyModules.open">unfold_less</i>
              <i class="material-icons"
                *ngIf="!legacyModules.open">unfold_more</i>
            </button>
          </div>
          <div class="content" *ngIf="legacyModules.open">
            <div class="row">
              <div class="col-md-12">
                <label i18n><strong>Módulos Habilitados:</strong></label>
                <div class="row mt-1">
                  <div class="col-md-3" *ngFor="let module of modulesBequest">
                    <mat-checkbox i18n
                      color="primary"
                      [disabled]="disabledLegacycheckBoxes"
                      [checked]="module.selected"
                      (change)="setModulesBequest(module)">
                      {{ module.name }}
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <app-input
                  class="input-group--input-prepend"
                  formControlName="bequestUrl"
                  type="text"
                  label="URL"></app-input>
              </div>
            </div>
          </div>
        </div>
        <section>
          <div id="limit mb-3">
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreLimit()">
                  <h5 class="mb-3" i18n><strong>Quantidade Limite
                    </strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreLimit()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldLimit === 'less'; else elseBlockTable1">unfold_less</i>
                    <ng-template #elseBlockTable1>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldLimit === 'more'" class="limited-height">
                <div class="card card-body">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-4">
                        <div class="form-group">
                          <app-input i18n-label="@@equipment" type="number"
                            formControlName="equipments"
                            (change)="checkNoZero($event,'equipments')"
                            label="Equipamento">
                          </app-input>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group">
                          <app-input i18n-label="@@spot" type="number"
                            formControlName="spots"
                            (change)="checkNoZero($event,'spots')"
                            label="Ponto">
                          </app-input>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group">
                          <app-input i18n-label="@@lane" type="number"
                            formControlName="lanes"
                            (change)="checkNoZero($event,'lanes')"
                            label="Faixa">
                          </app-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div [id]="'speed'" *ngIf="speed">
            <div
              class="table-responsive table-hover table-block mb-1 noOverFlow">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreSpeed()">
                  <h5 class="mb-3" i18n><strong>Cálculos de Velocidade
                    </strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreSpeed()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldSpeed === 'less'; else elseBlockTable2">unfold_less</i>
                    <ng-template #elseBlockTable2>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldSpeed === 'more'" class="limited-height">
                <div class="card card-body">
                  <div class="form-group">
                    <div class="row"
                      *ngFor="let itemSpeed of contractForm.get('speedCalculations')['controls']; let iSpeed = index">
                      <div class="col-6">
                        <div [formGroup]="itemSpeed">
                          <app-input type="select" [list]="regulations"
                            label="Selecione o Enquadramento"
                            formControlName="regulationId"
                            selectText="prettyName" selectValue="id"
                            placeholder="Enquadramento"
                            (ngModelChange)="addformula($event, iSpeed, itemSpeed)"
                            id="regulationId-{{iSpeed}}"
                            i18n-placeholder i18n-label>
                          </app-input>
                        </div>
                      </div>
                      <div class="col-2">
                        <div [formGroup]="itemSpeed">
                          <app-input i18n-label="@@initialSpeedFormula"
                            type="text"
                            [inputDisabled]="checkregulation(itemSpeed)"
                            id="initialSpeedFormula-{{iSpeed}}"
                            formControlName="initialSpeedFormula"
                            label="Fórmula Inicial">
                          </app-input>
                        </div>
                      </div>
                      <div class="col-2">
                        <div [formGroup]="itemSpeed">
                          <app-input i18n-label="@@finalSpeedFormula"
                            type="text"
                            [inputDisabled]="checkregulation(itemSpeed)"
                            id="finalSpeedFormula-{{iSpeed}}"
                            formControlName="finalSpeedFormula"
                            label="Fórmula Final">
                          </app-input>
                        </div>
                      </div>
                      <div class="col-2 mt-4">
                        <div [formGroup]="itemSpeed">
                          <span [routerLink]
                            (click)="removeSpeedCalculations(iSpeed)"
                            class="btn text-danger btn-icon-block"
                            data-placement="top" i18n-appTooltip
                            appTooltip="Apagar registro">
                            <i class="material-icons">remove_circle</i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <button type="button" class="btn btn-fade-info mt-3"
                          (click)="addSpeedCalculations()">
                          Adicionar Novo
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="contract.id" [id]="'template'">
            <div
              class="table-responsive table-hover table-block mb-1 noOverFlow">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreTemplate()">
                  <h5 class="mb-3" i18n><strong>Templates AIT </strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreTemplate()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldTemplate === 'less'; else elseBlockTable3">unfold_less</i>
                    <ng-template #elseBlockTable3>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldTemplate === 'more'" class="limited-height">
                <div class="card card-body">
                  <div class="form-group">
                    <div class="row"
                      *ngFor="let itemTemplate of contractForm.get('aitTemplates')['controls']; let iTemplate = index">
                      <div class="col-6">
                        <div [formGroup]="itemTemplate">
                          <app-input i18n-label i18n-placeholder
                            placeholder="Selecione o enquadramento"
                            label="Enquadramentos" type="multiselect"
                            selectText="prettyName" selectValue="id"
                            [list]="regulations" formControlName="regulationIds"
                            selectShowLimit="5">
                          </app-input>
                        </div>
                      </div>
                      <div class="col-4">
                        <div [formGroup]="itemTemplate">
                          <app-input type="select" [list]="filetemplates"
                            label="Template" formControlName="templateId"
                            selectText="type" selectValue="id"
                            i18n-placeholder i18n-label>
                          </app-input>
                        </div>
                      </div>
                      <div class="col- mt-4">
                        <div [formGroup]="itemTemplate">
                          <span [routerLink]
                            (click)="removeAitTemplates(iTemplate)"
                            class="btn text-danger btn-icon-block"
                            data-placement="top" i18n-appTooltip
                            appTooltip="Apagar registro">
                            <i class="material-icons">remove_circle</i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <button type="button" class="btn btn-fade-info mt-3"
                          (click)="addAitTemplates()">
                          Adicionar Novo
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div [id]="'additional'">
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreAdditional()">
                  <h5 class="mb-3" i18n><strong>Campos Adicionais
                    </strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreAdditional()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldAdditional === 'less'; else elseBlockTable4">unfold_less</i>
                    <ng-template #elseBlockTable4>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldAdditional === 'more'"
                class="limited-height">
                <div class="card card-body">
                  <div class="form-group">
                    <div class="row"
                      *ngFor="let itemExtra of contractForm.get('extraData')['controls']; let iExtra = index">
                      <div class="col-5">
                        <div [formGroup]="itemExtra">
                          <app-input i18n-label="@@Campo" type="text"
                            formControlName="title"
                            (keyup)="checkCaracterLength($event, iExtra,'title', 50)"
                            label="Nome">
                          </app-input>
                        </div>
                      </div>
                      <div class="col-5">
                        <div [formGroup]="itemExtra">
                          <app-input i18n-label="@@Valor" type="text"
                            formControlName="value"
                            (keyup)="checkCaracterLength($event, iExtra,'value', 254)"
                            [inputDisabled]="checkExtraData(itemExtra)"
                            [inputRequired]="!checkExtraData(itemExtra)"
                            label="Valor">
                          </app-input>
                        </div>
                      </div>
                      <div class="col-2  mt-4">
                        <div [formGroup]="itemExtra">
                          <span [routerLink] (click)="removeExtraData(iExtra)"
                            class="btn text-danger btn-icon-block"
                            data-placement="top" i18n-appTooltip
                            appTooltip="Apagar registro">
                            <i class="material-icons">remove_circle</i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <button type="button" class="btn btn-fade-info mt-3"
                          (click)="addExtraData()">
                          Adicionar Novo
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" (click)="onCancel()">
        <app-loading [promise]="promise" text="Cancelar"
          i18n-text></app-loading>
      </button>
      <button class="btn btn-primary" (click)="onSubmit()"
        [ngClass]="{disabled: !isValid}">
        <app-loading [promise]="promise" text="Confirmar"
          i18n-text></app-loading>
      </button>
    </div>
  </div>
</div>
